import "./polyfill";
import { I18nextProvider } from "react-i18next";
import { i18n } from "./i18n";
import { BudgetCalculatorLayout, ErrorFallbackMessage, WithLoadingIndicator } from "./components";
import { AppProvider, CalculatorEnv } from "./state";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { parseBooleanAttribute, removeTrailingSlash } from "./api";
import { JSX } from "react";
import { ErrorBoundary } from "@sentry/react";
import { getSentryScope } from "./tracking";

type BudgetCalculatorAppProps = {
  apiUrl?: string;
  calculatorEnv?: CalculatorEnv;
  showHeader?: string;
};

const BudgetCalculatorApp = (props: BudgetCalculatorAppProps): JSX.Element => {
  const { apiUrl = "", calculatorEnv = "agpss", showHeader } = props;

  const sanitizedApiUrl = apiUrl && removeTrailingSlash(sanitizeUrl(apiUrl));
  const parsedShowHeader = parseBooleanAttribute(showHeader);

  return (
    <ErrorBoundary
      onError={(error, componentStack, eventId) => {
        const sentryScope = getSentryScope();
        sentryScope?.setExtra("componentStack", componentStack);
        sentryScope?.captureException(error, { event_id: eventId });
      }}
      fallback={<ErrorFallbackMessage />}
    >
      <AppProvider apiUrl={sanitizedApiUrl} calculatorEnv={calculatorEnv} showHeader={parsedShowHeader}>
        <I18nextProvider i18n={i18n}>
          <WithLoadingIndicator>
            <BudgetCalculatorLayout />
          </WithLoadingIndicator>
        </I18nextProvider>
      </AppProvider>
    </ErrorBoundary>
  );
};

export default BudgetCalculatorApp;
